import { configureStore } from "@reduxjs/toolkit";

// The app currently keeps state in local component state + custom hooks (not
// Redux), but the store is still mounted via <Provider>. An empty reducer map
// makes Redux throw "Store does not have a valid reducer" on every dispatch,
// which spams the console. Register a no-op root reducer until real slices land.
const noopReducer = (state = {}) => state;

const store = configureStore({
  reducer: {
    app: noopReducer
  }
});

export default store;
